import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { TableSearch } from "ui/components/Table/TableSearch";
import { CASCO_EXPIRY_SEARCH_COLUMNS } from "./consts";
import { CascoSearchResultsProps } from "./types";

const CascoSearchResults: React.FC<CascoSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onPaginationChange,
    onSelectedChange,
    onVehicleClick,
  } = props;

  return (
    <TableSearch
      columns={CASCO_EXPIRY_SEARCH_COLUMNS(onVehicleClick)}
      data={searchResults.data}
      selectedRows={selectedRows}
      pagination={
        searchResults.pagination || initialDataWithPagination.pagination
      }
      selectableRows={false}
      onPaginationChange={onPaginationChange}
      onSelectedChange={onSelectedChange}
      isLoading={isLoading}
    />
  );
};

export default memo(CascoSearchResults);
